import { Order } from './orderbook.model';
import { SwapHistoryColumns } from './swap-history.model';
import { TradeHistoryColumns } from './trade-history.model';

export class SelectOnBehalfUserAction {
  orders: Array<Order>;
  swapHistory: Array<SwapHistoryColumns>;
  trades: Array<TradeHistoryColumns>;
  selectedUser: string;
  abosPositions: Array<any>;

  constructor(orders: Array<Order>, swapHistory: Array<SwapHistoryColumns>, trades: Array<TradeHistoryColumns>, selectedUser: string, abosPositions: Array<any>) {
    this.orders = orders;
    this.swapHistory = swapHistory;
    this.trades = trades;
    this.selectedUser = selectedUser;
    this.abosPositions = abosPositions;
  }
}
